import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {

  SAVE_MCP_TASK_REQUEST: '',
  SAVE_MCP_TASK_SUCCESS: '',
  SAVE_MCP_TASK_FAILURE: '',

  DELETE_MCP_TASK_REQUEST: '',
  DELETE_MCP_TASK_SUCCESS: '',
  DELETE_MCP_TASK_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityHEDIS');

export default types;
